import numeral from 'numeral';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { secondsToHumanReadable } from '@/helpers/date-helper';
import { locales } from '@/helpers/date-locales';
import { useTypedStore } from '@/store';

type Currency = { code: string; symbol?: string | null };

export const useFormatters = () => {
  const { locale } = useI18n();
  const store = useTypedStore();
  const currencies = computed<Currency[]>(() => store.getters['misc/currencies'] as Currency[]);

  const getCurrencyLabel = (code: string | null) => {
    if (!code) {
      return '$';
    }

    const currency = currencies.value.find((el) => el.code === code);
    return currency?.symbol || `${code} `;
  };

  const formatCurrencyValue = (currencyCode: string | null, amount: number | null) => {
    if (amount === null) {
      return '';
    }

    const label = getCurrencyLabel(currencyCode);
    return `${label}${numeral(amount).format('0,0.00')}`;
  };

  const formatMoneyNoFrac = (amount: number | null) => {
    if (amount === null) {
      return '';
    }

    return `${numeral(amount).format('0,0')}`;
  };

  const formatDuration = (seconds: number = 0) => {
    return secondsToHumanReadable(seconds.toString(), locales[locale.value as keyof typeof locales]);
  };

  const formatValuePerDays = (periodSeconds: number) => {
    return Math.round(((periodSeconds || 0) / 86400));
  };

  return {
    getCurrencyLabel,
    formatCurrencyValue,
    formatMoneyNoFrac,
    formatDuration,
    formatValuePerDays,
  };
};
